export const translation = {
  projectName: 'DONATA VON HARDENBERG',

  header: {
    navigation: {
      default: [{ name: 'Startseite', link: '/' }],
      isLoggedIn: {
        name: 'Abmelden',
      },
    },
  },

  logo: 'DONATA VON HARDENBERG',

  home: {
    hero: {
      text: ['Ich erkläre Politik', 'nah am Menschen'],
    },
    separator: {
      bullets: ['Journalistin', 'Reporterin', 'Moderatorin'],
    },
    intro: {
      headline: ['Ich erkläre Politik', 'nah am Menschen'],
      subline: 'Auf den Punkt, schlagfertig, präsent',
      text: [
        'Verwirrt von Sprachfloskeln, Kauderwelsch und Wortmonstern im politischen Betrieb? Wer nicht? Das geht vielen so. Dabei haben politische Entscheidungen ganz viel mit Dir zu tun.',
        '<br/><strong>Deshalb frage ich mich immer:</strong>',
        'Was bedeutet Politik für Dein Leben?',
        'Was bleibt, was ändert sich, welche Partei will was?',
        '<br/>Das zu erklären, zu veranschaulichen und herauszuarbeiten ist meine Aufgabe und Verantwortung- ob im Nachrichtenbeitrag, im Interview oder in der Live Schalte.',
      ],
    },
    who: {
      headline: ['Wer bin ich'],
      subline: 'Politik ist meine Leidenschaft seitdem ich denken kann',
      text: [
        'Deshalb hat mich mein Weg schnurstracks zum Studium in die Hauptstadt geführt. Geschichte und Politik mußte es sein. Für meinen Master ging es für 2 Semester an die Science Po nach Paris- bekannt als französische Kaderschmiede für Politiker und Beamte. Es folgten zahlreiche Praktika im Nachrichtenbereich: in Leipzig bei MDR aktuell, im ZDF Studio Paris, in der Parlamentsredaktion von N24 und schließlich im Washingtoner Büro von N24. ',
        '<br/>Das journalistische Handwerkszeug habe ich als Volontärin bei N24, nach den ersten Sprüngen ins kalte Wasser, noch einmal von der Pike auf gelernt: Recherche, Drehen, Nachrichtenbeiträge texten, schneiden und vertonen, Interviewtechniken, Reportertraining, Lehrgang der Bundeswehr für Reporter im Kriegsgebiet. Mein Fokus: immer die Politikredaktion, die meine Stammredaktion bei N24 war.',
        '<br/>Als freie Redakteurin ging es bei N24 weiter- vor und hinter der Kamera. Meine Aufgaben: Nachrichtenbeiträge produzieren, schneiden, vertonen, drehen und Interviews führen- mit Spitzenpolitikern, Funktionären oder den Menschen auf der Straße.',
      ],
    },
    journalismus: {
      headline: ['Warum guter Journalismus', 'so wichtig ist'],
      subline: 'Qualität und Geschwindigkeit müssen vereinbar sein',
      text: [
        'Unser Nachrichtenverhalten hat in letzten Jahren noch einmal so richtig an Geschwindigkeit aufgenommen. Politische Ereignisse wie Regierungserklärungen, Parteitage oder Wahlen müssen schleunigst journalistisch aufbereitet werden- am besten sofort. Gestandene Profis fassen live das Wichtigste zusammen und reagieren teilweise ad hoc auf Breaking News. Der Qualitätsanspruch muss trotz des immensen Zeitdrucks hochgehalten werden. ',
        '<br/>Die Journalistischen Standards gelten: Sorgfalt, Distanz und Objektivität. Wir ausgebildeten Journalisten dürfen Amateuren nicht das Feld überlassen.',
      ],
    },
  },

  contact: {
    headline: 'Kontakt',
    text: 'Ich freue mich von Ihnen zu hören.',
    mail: 'mail@donatahardenberg.de',
  },

  footer: {
    legalLinks: [
      { name: 'Impressum', link: '/impressum' },
      { name: 'Datenschutz', link: '/datenschutz' },
    ],
  },

  generic: {
    country: {
      AUSTRIA: 'Österreich',
      BELGIUM: 'Belgien',
      BULGARIA: 'Bulgarien',
      CROATIA: 'Kroatien',
      CYPRUS: 'Zypern',
      CZECH_REPUBLIC: 'Tschechien',
      DENMARK: 'Dänemark',
      ESTONIA: 'Estland',
      FINLAND: 'Finnland',
      FRANCE: 'Frankreich',
      GERMANY: 'Deutschland',
      GREECE: 'Griechenland',
      HUNGARY: 'Ungarn',
      IRELAND: 'Irland',
      ITALY: 'Italien',
      LATVIA: 'Lettland',
      LITHUANIA: 'Litauen',
      LUXEMBOURG: 'Luxemburg',
      MALTA: 'Malta',
      NETHERLANDS: 'Niederlande',
      POLAND: 'Polen',
      PORTUGAL: 'Portugal',
      ROMANIA: 'Rumänien',
      SLOVAKIA: 'Slowakei',
      SLOVENIA: 'Slowenien',
      SPAIN: 'Spanien',
      SWEDEN: 'Schweden',
    },
    level: {
      title: 'Rolle',
      ADMIN: 'Administrator',
      MEMBER: 'Mitarbeiter',
    },
    company: {
      name: 'Donata von Hardenberg',
      street: '',
      city: '',
      phone: '',
      mail: 'mail@donatahardenberg.de',
    },
    certificate: {
      type: {
        BASE: 'Basiszertifikat',
        RENEWAL: 'Erneuerungszertifikat',
        NONE: 'Kein Zertifikat',
      },
    },
    firmaPrefix: 'Firma: ',
    countryPrefix: 'Land: ',
    firstnamePrefix: 'Vorname: ',
    lastnamePrefix: 'Nachname: ',
    ansprechpartnerPrefix: 'Ansprechpartner: ',
    telPrefix: 'Tel.: ',
    mailPrefix: 'E-Mail: ',
    streetPrefix: 'Straße: ',
    houseNumberPrefix: 'Hausnummer: ',
    plzPrefix: 'PLZ: ',
    cityPrefix: 'Ort: ',
    paid: 'Bezahlt',
    unpaid: 'Nicht bezahlt',
    timeSuffix: ' Uhr',
    umGlue: ' um ',
    date: 'Datum',
    all: 'Alle',
    amountSuffix: ' Stück',
    settings: 'Einstellungen',
    hourSuffix: ' Stunden',
    singleDaySuffix: ' Tag',
    pluralDaySuffix: ' Tage',
    squareMeterSuffix: ' m²',
    percentageSuffix: ' %',
    euroSuffix: ' €',
    equals: ' = ',
    timestampPrefix: 'Erstellt am: ',
    phonePrefix: 'Telefon: ',
    websitePrefix: 'Webseite: ',
    employeeSuffix: ' Mitarbeiter',
    salutation: 'Anrede',
    name: 'Name',
    firstname: 'Vorname',
    lastname: 'Nachname',
    birthday: 'Geburtsdatum',
    personType: 'Art',
    personTypePlaceholder: 'Beirat, Entscheider, ...',
    street: 'Straße, Hausnummer',
    companyName: 'Firmenname',
    club: 'Verein (optional)',
    city: 'PLZ, Ort',
    mail: 'E-Mail-Adresse',
    identifier: 'E-Mail-Adresse',
    message: 'Nachricht',
    phone: 'Telefonnummer',
    password: 'Passwort',
    passwordRepeat: 'Passwort wiederholen',
    createdOn: 'Erstellt am',
    confirm: 'Bestätigen',
    cancel: 'Abbrechen',
    close: 'Schließen',
    send: 'Senden',
    error: 'Ein unerwarteter Fehler ist aufgetreten. Bitte versuche es später erneut.',
    acceptAGB: 'Ich akzeptiere die AGB',
    percent: ' %',
    kilometerSuffix: ' km',
    upload: 'Hochladen',
    login: 'Anmelden',
    logout: 'Abmelden',
    export: 'Export',
    import: 'Import',
    save: 'Speichern',
    copy: 'Kopieren',
  },

  UI: {
    carrierSelector: {
      label: 'Carrier wählen',
    },
    teamSelector: {
      label: 'Team wählen',
    },
    hotelManager: {
      title: 'Hotels',
      updateTitle: 'Hotel bearbeiten',
      addTitle: 'Hotel hinzufügen',
      addCTA: 'Hotel hinzufügen',
      empty: 'Keine Hotels vorhanden',
      location: 'Hotel',
      bookingLink: 'Buchungslink',
      error: {
        locationRequired: 'Bitte geben Sie einen Hotelnamen ein',
        bookingLinkRequired: 'Bitte geben Sie einen Buchungslink ein',
      },
    },
    voucherManager: {
      title: 'Gutscheine',
      updateTitle: 'Gutschein bearbeiten',
      addTitle: 'Gutschein hinzufügen',
      addCTA: 'Gutschein hinzufügen',
      empty: 'Keine Gutscheine vorhanden',
      name: 'Gutschein',
      percentage: 'Rabatt in Prozent',
      redeemAmount: 'Anzahl der Einlösungen',
      error: {
        nameRequired: 'Bitte geben Sie einen Gutscheinnamen ein',
        percentageRequired: 'Bitte geben Sie einen Prozentsatz ein',
        redeemAmountRequired: 'Bitte geben Sie einen Wert ein',
      },
    },
    waitForArray: {
      emptyArray: 'Keine Daten vorhanden',
    },
    statusSelect: {
      label: 'Status',
      options: {
        GOOD: 'Gut',
        MEDIUM: 'Mittel',
        BAD: 'Schlecht',
      },
    },
    countrySelect: {
      label: 'Land',
    },
    removeConfirmation: {
      title: 'Bestätigung',
      text: (itemName: string) => `Möchten Sie "${itemName}" wirklich löschen?`,
    },
    copyConfirmation: {
      title: 'Kopieren',
      text: (itemName: string) => `${itemName}-Kopie umbenennen zu:`,
      initNameSuffix: '-Kopie',
    },
    customerSelector: {
      label: 'Kundenauswahl',
    },
    projectSelector: {
      label: 'Projektauswahl',
    },
    contactPersonManager: {
      title: 'Kontaktpersonen',
      addTitle: 'Kontaktperson hinzufügen',
      updateTitle: 'Kontaktperson bearbeiten',
      empty: 'Keine Kontaktpersonen vorhanden',
      add: 'hinzufügen',
    },
    organizationUnitManager: {
      title: 'Organisationseinheiten',
      addTitle: 'Organisationseinheit hinzufügen',
      employeeAmountSuffixShort: ' MA',
      employeeAmountSuffix: ' Mitarbeiter',
      updateTitle: 'Organisationseinheit bearbeiten',
      empty: 'Keine Organisationseinheiten vorhanden',
      add: 'hinzufügen',
    },
    simpleList: {
      search: 'Suche',
      resultAmountSuffixPlural: ' Ergebnisse',
      resultAmountSuffixSingular: ' Ergebnis',
      noData: 'Keine Daten vorhanden',
    },
    multiList: {
      search: 'Suche',
      resultAmountSuffix: ' Ergebnisse',
      noData: 'Keine Daten vorhanden',
      cta: 'Ausführen',
      cancelCTA: 'Abbrechen',
      option: {
        EXPORT: 'Export',
        PROCESS: 'Verarbeiten',
        STOP: 'Stoppen',
      },
      export: {
        title: 'Export',
        identifier: 'Kennung',
      },
      error: 'Aktion konnte nicht ausgeführt werden',
    },
    csvImport: {
      title: 'Import',
      startCTA: 'Import starten',
      loading: 'Daten werden imporiert...',
      error: 'Der Import ist fehlgeschlagen.',
    },
    dropdown: {
      emptySelection: 'Bitte wählen',
      search: 'Suche',
    },
    selectableTagList: {
      showMore: 'Mehr anzeigen',
      showLess: 'Weniger',
    },
    textarea: {
      max: {
        prefix: 'maximal ',
        suffix: ' Zeichen',
      },
    },
    dnd: {
      text: 'Bewerbung anhängen',
      hint: '(Erlaubt ist eine PDF-Datei bis zu 25 MB)',
      selectedPrefix: 'Gewählte PDF: ',
      error: {
        size: 'Maximale Dateigröße überschritten',
      },
    },
  },

  resetPassword: {
    passwordsDontMatch: 'Passwörter stimmen nicht überein',
    passwordReset: 'Passwort wurde erfolgreich geändert',
    save: 'Ändern',
    password: 'Passwort',
    passwordRepeat: 'Passwort wiederholen',
    title: 'Passwort ändern',
  },
}

export const langKey = 'DE'
